import { call, put, takeLatest } from "redux-saga/effects";

import * as apis from "../../network/apis/activityLogs";
import { showErrorMsg } from "../../utils/Helpers";
import * as actions from "./actions";
import * as types from "./types";

function* getActivityLogsSaga({ payload }) {
  try {
    const response = yield call(apis.getActivityLogs, payload);
    const data = response.data?.data;
    yield put(
      actions.getActivityLogsResponse({
        list: Array.isArray(data) ? data : [],
        meta: {
          currentPage: +response.headers["current-page"] || 1,
          count: +response.headers["total-count"] || 0,
          pages: +response.headers["total-pages"] || 1,
        },
      }),
    );
  } catch (error) {
    yield put(actions.getActivityLogsFailure());
    const message = error.response?.data?.message;
    if (message) {
      yield call(showErrorMsg, message);
    }
  }
}

export default function* ActivityLogsSagas() {
  // Latest wins — a slower earlier search must not overwrite newer results.
  yield takeLatest(types.GET_ACTIVITY_LOGS_REQUEST, getActivityLogsSaga);
}
